/** Resource types of the member Resources tab, in the order the Type filter lists them. */
export const RESOURCE_TYPE_ORDER = Object.freeze(['dataset', 'model', 'event_bus', 'sandbox']);
